import { uid } from "./uid";
import { defaultEditorShape, defaultMonthConfig, defaultConfig, defaultWeekConfig, defaultColors, defaultTimelineConfig, } from "./consts";
import { isDate, isEqual } from "date-fns";
export { uid } from "./uid";
export function normalizeEditor(state) {
    const editorShape = state.editorShape || defaultEditorShape;
    return editorShape.map((field) => {
        if ("options" in field || "colors" in field) {
            field.values = field.options || field.colors;
        }
        if (field.type === "combo" && field.key === "type") {
            field.options = state.calendars;
        }
        field.id = field.id || uid();
        return field;
    });
}
export function normalizeConfig(config) {
    const normalized = {
        ...defaultConfig,
        ...config,
    };
    const { timeRange, timeStep, eventsOverlay, eventHeight, views } = normalized;
    const weekStartsOn = normalized.weekStartsOn;
    let { dateClick } = normalized;
    normalized.views = views.map(view => {
        const { config, ...rest } = view;
        const { layout } = rest;
        let defaults = { cellCss: () => "", eventHeight };
        switch (layout) {
            case "day":
            case "week":
                defaults = {
                    ...defaults,
                    timeRange,
                    timeStep,
                    eventsOverlay,
                    ...defaultWeekConfig,
                    ...config,
                    weekStartsOn,
                };
                break;
            case "month":
                defaults = {
                    ...defaults,
                    ...defaultMonthConfig,
                    ...config,
                    weekStartsOn,
                };
                break;
            case "timeline":
                defaults = {
                    ...defaults,
                    ...defaultTimelineConfig,
                    ...config,
                };
        }
        return { ...rest, dateClick, config: { ...defaults } };
    });
    if (dateClick === null || dateClick === undefined || dateClick === true) {
        const dayView = views.find(({ layout }) => layout === "day");
        dateClick = dayView?.id || "day";
    }
    //set to false  if there's no view with such id
    if (dateClick && !views.find(({ id }) => id === dateClick)) {
        dateClick = false;
    }
    return { ...normalized, dateClick };
}
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function normalizeCalendars(calendars, colors = defaultColors) {
    return calendars.map((calendar, i) => {
        return {
            color: colors[i % colors.length],
            id: uid(),
            active: true,
            ...calendar,
        };
    });
}
export function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.substring(1);
}
export function isDeepEqual(object1, object2) {
    if (object1 === object2)
        return true;
    if (isDate(object1) && isDate(object2)) {
        return isEqual(object1, object2);
    }
    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);
    if (objKeys1.length !== objKeys2.length)
        return false;
    for (const key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];
        const isObjects = isObject(value1) && isObject(value2);
        if ((isObjects && !isDeepEqual(value1, value2)) ||
            (!isObjects && value1 !== value2)) {
            return false;
        }
    }
    return true;
}
export function isObject(object) {
    return object != null && typeof object === "object";
}
export function getDeepCopy(object) {
    const copy = object instanceof Array
        ? []
        : object instanceof Date
            ? new Date(object)
            : {};
    Object.entries(object).forEach(([key, value]) => {
        copy[key] = isObject(value) ? getDeepCopy(value) : value;
    });
    return copy;
}
export function timelineHeaderStyles(node, config) {
    function setStyles(config) {
        const target = node;
        const { style } = target;
        const { index, colsWidth } = config;
        style.minWidth = `${colsWidth}px`;
        style.top = `${index * target.offsetHeight}px`;
    }
    setStyles(config);
    return {
        update: (nextConfig) => setStyles(nextConfig),
    };
}
export function isDefined(val) {
    return val !== undefined && val !== null;
}
//# sourceMappingURL=helpers.js.map